var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.576 78C20.5109 67.4603 23.2083 61.4212 27.1012 55.7311C31.3643 49.5 32.4631 43.3317 32.4631 43.3317C32.4631 43.3317 35.8143 47.6883 34.4738 54.5022C40.3944 47.9116 41.5115 37.4111 40.6178 33.3896C54.0005 42.7421 59.7199 62.9922 52.012 78C93.0083 54.8043 62.2095 20.0966 56.8476 16.1869C58.635 20.0965 58.9738 26.7148 55.3633 29.9267C49.2512 6.75 34.1388 2 34.1388 2C35.9261 13.9525 27.6598 27.0224 19.6887 36.7886C19.4086 32.0225 19.1111 28.7337 16.6049 24.1729C16.0423 32.8309 9.42555 39.8885 7.63376 48.5632C5.20666 60.311 9.45182 68.9125 25.576 78Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.317447c0731cb5f852affbec733da89c.svg";
export { ForwardRef as ReactComponent };